export default "__VITE_ASSET__e95a0d47__"